var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7803 8.03028C20.6397 8.17094 20.4489 8.24996 20.25 8.24996H19.5V18H21V19.5H3V18H4.5V8.24996H3.75C3.55109 8.24996 3.36032 8.17094 3.21967 8.03028C3.07902 7.88963 3 7.69887 3 7.49996V5.24996C3.00007 5.09582 3.04762 4.94545 3.13619 4.8193C3.22476 4.69316 3.35005 4.59736 3.495 4.54496L11.745 1.54496C11.9098 1.48538 12.0902 1.48538 12.255 1.54496L20.505 4.54496C20.65 4.59736 20.7752 4.69316 20.8638 4.8193C20.9524 4.94545 20.9999 5.09582 21 5.24996V7.49996C21 7.69887 20.921 7.88963 20.7803 8.03028ZM12 3.04496L4.5 5.77496V6.74996H19.5V5.77496L12 3.04496ZM10.5 8.24996V18H13.5V8.24996H10.5ZM9 8.24996H6V18H9V8.24996ZM15 18H18V8.24996H15V18ZM1.5 22.5V21H22.5V22.5H1.5Z",
    fill: "#050A25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.d0e4939b0db32b274c7d3adf16a28973.svg";
export { ForwardRef as ReactComponent };